export default __webpack_public_path__ + "static/media/hero-bg.cff27f94.png";